/**
 * Users
 */

// React
import React, { FunctionComponent, useEffect, useState, useContext } from 'react';

import { useForm } from 'react-hook-form';
// Context
import AuthContext from '../../authContext';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getUsersAction,
  updateUserActions,
  createUserActions,
  updateUserStatusActions,
} from './actions';
import { getCentersAction } from '../centers/actions';
import { getPartnersAction } from '../partners/actions';
import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectUsersList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
} from './selectors';
import { makeSelectList as makeSelectCentersList } from '../centers/selectors';
import { makeSelectPartnersList } from '../partners/selectors';

// Components
import Pagination from '@material-ui/lab/Pagination';
import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import List from './componets/list';
import Edit from './componets/edit';
import Add from './componets/add';
import Detail from './componets/detail';
import Assign from './componets/assign';
import Modal from '../../components/Modal';
import Can from '../../components/Can';

// UI
import theme from '../../theme';
import clsx from 'clsx';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  Grid,
  DialogTitle,
  IconButton,
  FormControl,
  Select,
  MenuItem,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiPlus,
  mdiClose,
  mdiCheck,
  mdiAccountDetailsOutline,
  mdiPencilOutline,
  mdiAccountOutline,
  mdiPhoneOutline,
  mdiAccountKeyOutline,
  mdiStateMachine,
  mdiAccountPlusOutline,
  mdiUpdate,
} from '@mdi/js';

// Helper
import { removeEmptyValueObject } from '../../utils/helpers';

// Type
import {
  Props,
  SelectorProps,
  PayloadUpdate,
  PayloadCreate,
  User,
} from './interfaces';
import type { Filter } from '../../utils/listDaynamicFilter';
import roleRepository from 'client-sdk/src/Repository/roles-repository';
import useQuery from '../../utils/hook/useQuery';
import CommonRepository from 'client-sdk/src/Repository/common-repository'
import handleNotfication from '../../utils/handleNotfication';
import handleError from '../../utils/handleError';

type Inputs = {
  'name.contains': string;
};

// StyleExpansionPanel
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      padding: '10px 0',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      marginRight: '10px',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '30px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },

    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

const Users: FunctionComponent<Props> = (props: Props) => {
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const authContext = useContext(AuthContext);
  const [filters, setFilters] = useState([] as Filter[]);
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
  } as any);
  const [openConfirmDisable, setOpenConfirmDisable] = useState(
    false as boolean
  );
  const [roles, setRoles] = useState<any>([]);
  const [openConfirmActive, setOpenConfirmActive] = useState(false as boolean);
  const [openDialog, setOpenDialog] = useState(false as boolean);
  const [type, setType] = useState('edit' as string);
  const [openAdd, setOpenAdd] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const filterTranslator = (fieldName: string) => {
    const status = {
      name: 'نام کاربر',
      'name.equals': 'نام کاربر:',
      'name.contains': 'نام کاربر:',
      phoneNumber: 'شماره تماس کاربر',
      'phoneNumber.equals': 'شماره تماس کاربر',
      'phoneNumber.contains': 'شماره تماس کاربر',
      'id.equals': 'کد کاربر:',
      'id.contains': 'کد کاربر:',
      role: 'نقش کاربر',
      'role.equals': 'نقش کاربر:',
      'role.contains': 'نقش کاربر:',
      emailAddress: 'ایمیل کاربر',
      'emailAddress.equals': 'ایمیل کاربر:',
      'emailAddress.contains': 'ایمیل کاربر:',
    };
    return status[fieldName];
  };
  const removeFilterHandler = (fieldName: any) => {
    const filtered = { ...filtersValues };
    delete filtered[fieldName];
    setFiltersValues(filtered);
  };

  useEffect(() => {
    getUsers();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps
  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  useEffect(() => {
    getRoles({ page: 0, size: 100 });
  }, []);

  const getRoles = async (actions: any) => {
    const payload = { ...actions };
    try {
      const { response, callback } = await roleRepository.getRoles({
        payload,
      });
      setRoles(response.data);
      callback && callback();
    } catch (error) { }
  };

  const getUsers = () => {
    const { page, size } = filtersValues;
    props.usersDispatch({
      ...removeEmptyValueObject(filtersValues),
      "role.equals": authContext.user.role === "MARKETING_MANAGER" ? "PARTNER_ADMIN" : null,
      page,
      size,
    });
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'name.contains',
        label: 'نام کاربر',
        icon: mdiAccountOutline,
      },
      {
        type: 'input',
        id: 'phoneNumber.contains',
        label: 'شماره همراه کاربر',
        icon: mdiPhoneOutline,
      },
      {
        type: 'number',
        id: 'id.equals',
        label: 'کد کاربر',
        icon: mdiAccountKeyOutline,
      },
      {
        type: 'checkbox',
        id: 'role.in',
        label: 'نقش کاربر',
        data: [
          'DRIVER',
          'CENTER_ADMIN',
          'PARTNER_ADMIN',
          'RONAD_ADMIN',
          'LOGISTICS_ADMIN',
          'WAREHOUSE_ADMIN',
          'MARKETING_MANAGER',
          'MARKETING_EXPERT',
          'OPERATIONS_MANAGER',
          'OPERATIONS_EXPERT',
          'SUPPORT_MANAGER',
          'SUPPORT_EXPERT',
          'AGENCY_ADMIN',
          'WAREHOUSE_OPERATOR',
          'NONE',
        ],
        translateType: 'user',
        icon: mdiStateMachine,
      },
    ]);
  };
  const headCells = [
    {
      id: 'name',
      label: 'نام کاربر',
      type: 'input',
    },
    { id: 'id', label: 'کد کاربر', type: 'input' },
    { id: 'phoneNumber', label: 'شماره تماس کاربر', type: 'input' },
    { id: 'emailAddress', label: 'ایمیل کاربر', type: 'input' },
    {
      id: 'role',
      label: 'نقش کاربر',
      type: 'checkbox',
      data: [
        'RONAD_ADMIN',
        'MARKETING_MANAGER',
        'MARKETING_EXPERT',
        'OPERATIONS_MANAGER',
        'OPERATIONS_EXPERT',
        'SUPPORT_MANAGER',
        'SUPPORT_EXPERT',
        'WAREHOUSE_SUPERVISOR',
        'WAREHOUSE_ADMIN',
        'WAREHOUSE_OPERATOR',
        'PARTNER_ADMIN',
        'AGENCY_ADMIN',
        'CENTER_ADMIN',
        'SELLER_ADMIN',
        'DRIVER',
        'LOGISTICS_ADMIN',
        'FINANCIAL_SUPERVISOR',
      ],
    },
  ];
  const head = { headCells };
  const handleDisableUser = async () => {
    await props.updateUserStatusDispatch({
      id,
      body: 'SUSPENDED'.replace(/'/g, '"'),
      pagination: filtersValues,
    });

    setOpenConfirmDisable(false);
  };
  const handleActiveUser = async () => {
    await props.updateUserStatusDispatch({
      id,
      body: 'ACTIVE'.replace(/'/g, '"'),
      pagination: filtersValues,
    });

    setOpenConfirmActive(false);
  };

  const handleOpenConfirmDisable = (id: number) => {
    setOpenConfirmDisable(true);

    setId(id);
  };
  const handleOpenConfirmActive = (id: number) => {
    setOpenConfirmActive(true);
    setId(id);
  };
  const handleOpen = (id: number, type: string) => {
    setType(type);
    setOpenDialog(true);
    setId(id);
  };

  const handleClose = () => {
    setOpenConfirmDisable(false);
    setOpenConfirmActive(false);
    setOpenDialog(false);
    setOpenAdd(false);
    setOpenSize(false);
  };

  const handleOpenConfirmUpdateState = (data: { id: number; body: any }) => {
    setId(data.id);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const onInit = async () => {
    try {
      await CommonRepository.ticketInit({})
      handleNotfication("همگام سازی با موفقیت انجام شد", "success")
    } catch (error) {
      handleError(error)
    }
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={6}>
        <Grid container item xs={12} sm={6} alignItems="center">
          <Typography variant="h6" component={'span'}>
            {`لیست کاربران`}
          </Typography>
        </Grid>
        <Grid item sm={6} xs={12}>
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 10,
              });
            }}
            mainFiltersCount={0}
            baseFilter={{
              type: 'input',
              id: 'name.contains',
              placeholder: 'نام کاربر',
            }}
            filterValues={filtersValues}
          />
        </Grid>
        <Grid xs={6} item container alignItems="center">
          {props.loading ? (
            ''
          ) : (
            <>
              <div className={classes.subtitle}>{`تعداد کل کاربران:`}</div>
              <div>
                &nbsp;
                <b>{`${props.count}`}</b>
              </div>
            </>
          )}
        </Grid>
        <Grid container item xs={6} direction="row-reverse">
          {/* <CSV
            getData={props.allBundlesDispatch}
            data={props.allBundlesList}
            filtersValues={filtersValues}
            loading={props.loading}
          /> */}
          <Can
            role={authContext.user.role}
            perform="user:createNewUser"
            yes={() => (
              <Button
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<Icon path={mdiPlus} size={1} />}
                onClick={() => {
                  setOpenAdd(true);
                }}
              >{`ایجاد کاربر جدید`}</Button>
            )}
          />
          <Button
            variant="contained"
            color="secondary"
            size="large"
            style={{ marginLeft: "10px" }}
            startIcon={<Icon path={mdiUpdate} size={1} />}
            onClick={onInit}
          >همگام سازی</Button>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          {props.loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <List
                data={props.usersList}
                handleOpenConfirmDisable={handleOpenConfirmDisable}
                handleOpenConfirmActive={handleOpenConfirmActive}
                handleOpen={handleOpen}
                changeStatus={handleOpenConfirmUpdateState}
                head={head}
                filterVal={filtersValues}
                onFilterValue={(filtervalues: any) => {
                  setFiltersValues({
                    ...removeEmptyValueObject(filtervalues),
                    ...filtersValues,
                    page: 0,
                    size: 10,
                  });
                }}
                removeFilterHandler={removeFilterHandler}
                filterLabelTranslator={filterTranslator}
              />
            </>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
              {' '}
              تعداد نمایش در هر صفحه:
            </div>
            <Select
              open={openSize}
              onClose={handleClose}
              onOpen={() => setOpenSize(true)}
              value={filtersValues.size}
              onChange={handleChangeSizePage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          <Pagination
            className={classes.pagination}
            count={Math.ceil(props.count / filtersValues.size)}
            color="secondary"
            page={filtersValues.page + 1}
            onChange={handleChangePage}
          />
        </Grid>
      </Grid>
      <Modal
        onClose={handleClose}
        maxWidth={type === 'edit' ? 'sm' : 'md'}
        open={openDialog}
        title={
          <div className={classes.editIcon}>
            {type === 'detail' && (
              <Icon path={mdiAccountDetailsOutline} size={4} />
            )}

            {type === 'edit' && (
              <Icon
                path={mdiPencilOutline}
                size={4}
                color={theme.palette.blue.main}
              />
            )}
          </div>
        }
        content={
          <>
            {type === 'edit' && (
              <Edit
                data={props.usersList.find(user => user.id === id)}
                roles={roles}
                updateUser={body => {
                  props.updateUserDispatch({
                    body,
                    pagination: filtersValues,
                    callback: () => handleClose(),
                  });
                }}
                error={props.error}
                onClose={handleClose}
              />
            )}
            {type === 'detail' && (
              <Detail data={props.usersList.find(user => user.id === id)} />
            )}

            {type === 'assign' && (
              <Assign
                data={props.usersList.find(user => user.id === id)}
                centersDispatch={props.centersDispatch}
                partnersDispatch={props.partnersDispatch}
                centers={props.centersList}
                partners={props.partnersList}
              />
            )}
          </>
        }
      />

      <Modal
        onClose={handleClose}
        open={openAdd}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiAccountPlusOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <Add
            onClose={handleClose}
            error={props.error}
            roles={roles}
            createUser={async (body: User, callback: () => void) => {
              await props.createUserDispatch({
                body,
                pagination: filtersValues,
                callback,
              });
            }}
          />
        }
      />

      <Dialog
        fullWidth
        open={openConfirmDisable || openConfirmActive}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div
            className={
              openConfirmDisable ? classes.cancelIcon : classes.editIcon
            }
          >
            {openConfirmDisable ? (
              <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
            ) : (
              <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
            )}
          </div>
          <div className={classes.cancelTitle}>
            {` آیا از 
          
          ${openConfirmDisable ? 'غیر' : ''}
          
          فعال کردن کاربر با نام
          "${props.usersList.find(user => user.id === id)?.name}"
          اطمینان دارید؟`}
          </div>
        </DialogTitle>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {`خیر`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              {openConfirmDisable ? (
                <Button
                  onClick={handleDisableUser}
                  fullWidth
                  variant="contained"
                  size="large"
                >
                  {`بله`}
                </Button>
              ) : (
                <Button
                  onClick={handleActiveUser}
                  fullWidth
                  variant="contained"
                  size="large"
                >
                  {`بله`}
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  usersList: makeSelectUsersList(),
  partnersList: makeSelectPartnersList(),
  centersList: makeSelectCentersList(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    usersDispatch: (payload: Object) => dispatch(getUsersAction(payload)),
    updateUserDispatch: (payload: PayloadUpdate) =>
      dispatch(updateUserActions(payload)),
    createUserDispatch: (payload: PayloadCreate) =>
      dispatch(createUserActions(payload)),
    updateUserStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateUserStatusActions(payload)),
    centersDispatch: (payload: Object) => dispatch(getCentersAction(payload)),
    partnersDispatch: (payload: Object) => dispatch(getPartnersAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Users);
